"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDayOfWeekDataFromSchedule = void 0;
require("../../../core");
const getDayOfWeekByNumber_1 = require("./getDayOfWeekByNumber");
const getScheduleSelectedIndex_1 = require("./getScheduleSelectedIndex");
const getDayOfWeekDataFromSchedule = (schedule) => {
    return getScheduleSelectedIndex_1.getScheduleSelectedIndex(schedule).map((dayIndex) => getDayOfWeekByNumber_1.getDayOfWeekByNumber(dayIndex));
};
exports.getDayOfWeekDataFromSchedule = getDayOfWeekDataFromSchedule;
//# sourceMappingURL=getDayOfWeekDataFromSchedule.js.map